module.exports = __webpack_public_path__ + "img/wenjianjia.a4ab679a.png";